module.exports = __webpack_public_path__ + "media/images/statistics-281a64e14bbba00996b89ed3b6e40f66.png";